import Config from '@configs/Environments';
import { useOktaAuth } from '@okta/okta-react';
import { useEffect } from 'react';

const LoginCheck = () => {
    const { oktaAuth } = useOktaAuth();
    useEffect(() => {
        if (Config.OKTA_AUTH_MODE) {
            oktaAuth.getUser().then(() => {
            }).catch(() => {
                window.location.reload();
            });
        }
    }, [oktaAuth]);
    return true;
}

export default LoginCheck;